import { useContent } from '@/content'
import { useDocumentMeta } from '@/hooks'
import { ROUTES } from '@/lib/paths'
import { Button, Reveal, Section, Surface } from '@/components/ui'
import { ResumeButton } from '@/features/profile'
import { AwardsSection } from '@/features/awards'
import { WorkTogetherCta } from '@/features/cta'
import { ExperienceSection } from '@/features/experience'
import { SkillMatrix } from '@/features/skills'
import styles from './AboutPage.module.css'

/** Biography and experience in one panel, then Service beside Awards. */
export const AboutPage = () => {
  const { education, experience, community: service, site } = useContent()
  useDocumentMeta({
    title: `About - ${site.name}`,
    description: site.bio,
  })

  return (
    <>
      <Section aria-labelledby="about-heading">
        <Surface pad={20} radius="shell">
          <div className={styles.bioGrid}>
            <div className={styles.portraitFrame}>
              <img
                src={site.portrait}
                alt={`${site.owner}, ${site.role}`}
                className={styles.portrait}
              />
            </div>

            <div className={styles.content}>
              <h1 id="about-heading" className={`t-14 ${styles.bio}`}>
                {site.bio}
              </h1>

              <ExperienceSection label="Experience" entries={experience} />

              <div className={styles.actions}>
                <ResumeButton />
                <Button to={ROUTES.contact} variant="secondary">
                  Get in touch
                </Button>
              </div>
            </div>
          </div>
        </Surface>
      </Section>

      <Reveal>
        <Section innerClassName={styles.panels} aria-label="Education and certifications">
          <Surface pad={20} radius="card">
            <ExperienceSection label="Education" entries={education} compact />
          </Surface>
          <AwardsSection />
        </Section>
      </Reveal>

      <Reveal>
        <Section>
          <SkillMatrix />
        </Section>
      </Reveal>


      <Reveal>
        <Section>
          <Surface pad={20} radius="card">
            <ExperienceSection label="Community & Service" entries={service} />
          </Surface>
        </Section>
      </Reveal>

      <Reveal>
        <WorkTogetherCta />
      </Reveal>
    </>
  )
}
